SETTINGS.services = {
    forms: {
        methods: {
            signup: '/Folkspel/Signup',
            register: '/Folkspel/CreateNewMember',
            contact: '/Folkspel/Contact',
            companysignup: '/Folkspel/CompanySignup',
            checkLottery: '/Folkspel/CheckTicket',
            sendQuestion: '/Folkspel/ContactAsLoggedIn',
            updateDetails: '/Folkspel/UpdateAccount',
            getLotteries: '/Folkspel/GetLotteries',
            getRounds: '/Folkspel/GetReturnTicketsRounds',
            getReturnInputs: '/Folkspel/GetReturnTicketsArticles',
            postReturnLottery: '/Folkspel/ReturnTickets',
            registerWinning: '/Folkspel/RegisterWinning',
            handoutPackage: '/Folkspel/HandOutPackage',
            activateBundle: '/Folkspel/ActivateBundle',
            returnTicket: '/Folkspel/ReturnTicket',
            getReturnReportTransactionSummary: '/Folkspel/GetReturnReportTransactionSummary',
            getWinningReportTransactionSummary: '/Folkspel/GetWinningReportTransactionSummary',
            login: '/Folkspel/Login',
            resetPassword: '/Folkspel/ResetPassword',
            resetPasswordFromMail: '/Folkspel/ResetPasswordFromMail',
            eldsjalnomination: '/Folkspel/EldsjalNomination',
            approveScannerConditions: '/Folkspel/ApproveScannerConditions'
        }
    },
    site: {
        methods: {
            getArticles: '/Folkspel/GetArticles',
            getQuestions: '/Folkspel/GetFAQQuestions',
            searchAssociation: '/Folkspel/FindAssociations',
            findAssociation: '/Folkspel/FindAssociation',
            getBannerCode: '/Folkspel/GetExternalBannerCode'
        }
    },
    admin: {
        methods: {
            blockBanner: '/Folkspel/BlockBanner',
            getCampaigns: '/Folkspel/GetCampaigns',
            getInvoices: '/Folkspel/GetInvoices',
            deleteAccount: '/Folkspel/EndAccount',
            getRemovedBlockedBanners: '/Folkspel/UnblockBanner',
            postSalesMateriel: '/Folkspel/PostSalesMateriel',
            getReports: '/Folkspel/GetReports',
            getWinners: '/Folkspel/GetWinners'
        }
    }
};

import lozad from "lozad";

$(function () {
    var observer = lozad();
    observer.observe();

    var $body = $("body");
    WidgetHandler.InitWidgets($body);
});